import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeRolloverGuideFields {
  subscriptionType: EntryFieldTypes.Symbol<'maths' | 'reading'>
  title: EntryFieldTypes.Symbol
  file: EntryFieldTypes.AssetLink
}

export type TypeRolloverGuideSkeleton = EntrySkeletonType<TypeRolloverGuideFields, 'rolloverGuide'>
export type TypeRolloverGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeRolloverGuideSkeleton,
  Modifiers,
  Locales
>

export function isTypeRolloverGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeRolloverGuide<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'rolloverGuide'
}

export type TypeRolloverGuideWithoutLinkResolutionResponse = TypeRolloverGuide<'WITHOUT_LINK_RESOLUTION'>
export type TypeRolloverGuideWithoutUnresolvableLinksResponse = TypeRolloverGuide<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeRolloverGuideWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeRolloverGuide<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeRolloverGuideWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeRolloverGuide<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeRolloverGuideWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeRolloverGuide<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
